import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";

/**
 * Confirmation dialog for syncing subscription from Squarespace.
 * Use in admin subscription detail when user clicks "Sync from Squarespace".
 */
export default function SyncFromSquarespaceConfirmDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="sync-from-ss-dialog-title"
      aria-describedby="sync-from-ss-dialog-description"
    >
      <DialogTitle id="sync-from-ss-dialog-title">
        Sync from Squarespace?
      </DialogTitle>
      <DialogContent>
        <Typography id="sync-from-ss-dialog-description">
          This will pull the latest data from Squarespace and update the
          subscription in the system. Use this to resolve sync issues between
          the subscription and Squarespace data (e.g. status, auto-renew,
          renewal date).
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <SyncIcon />
            )
          }
        >
          {loading ? "Syncing…" : "Yes, sync from Squarespace"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
